// extracted by mini-css-extract-plugin
module.exports = {"overlay":"iframe-module--overlay--2DDpb","active":"iframe-module--active--dwWHm","videoIframe":"iframe-module--videoIframe--2LcJs"};